import { AmountString } from "../types/common";

export const AmountFormatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const formatAmount = (amount: string | number): string =>
    AmountFormatter.format(
        typeof amount === "number" ? amount : Number.parseFloat(amount),
    );

type Amount = {
    currency: string;
    amount: string;
};
export const parseAmountString = (amountString: AmountString): Amount => {
    const result = amountString.split(" ");
    return {
        amount: result[0] ?? "",
        currency: result[1] ?? "",
    };
};

export const stringifyAmount = (amount: Amount): AmountString =>
    `${amount.amount} ${amount.currency}`;
